module.exports = __webpack_public_path__ + "img/contact-message-icon.ea48d24c.svg";